// @flow
/**
 * Event Formatter
 *
 * Utility for formatting video tracking events with consistent structure.
 * Extracted to avoid duplication between actions.js and video-progress-service.js.
 */

import {
  getBrowserVersion,
  isAndroid
} from '../../../common/js/environment-utils';

/**
 * Formats an event object into a tracking string.
 * Includes browser version info automatically.
 *
 * @param event - Object with 'event' name and optional 'options'
 * @returns Formatted string like "eventName#{"chromeVersion":"99",...}"
 */
export const formatEvent = (event: {
  event: string;
  options?: Object;
}): string => {
  const defaultEventOptions = {
    [isAndroid() ? 'chromeVersion' : 'safariVersion']: getBrowserVersion()
  };

  return `${event.event}#${JSON.stringify({
    ...defaultEventOptions,
    ...event.options
  })}`;
};
